const authPagePathPatterns = [
  /^\/user\/login/,
  /^\/user\/campaign\/login$/,
  /^\/user\/campaigns\/create\/conditional\/login$/,
  /^\/user\/invitation\//,
  /^\/contribute\/recurring\/login\/create$/,
];

export function isAuthPagePath(pathname) {
  return authPagePathPatterns.some((pattern) => pattern.test(pathname));
}
